import { BRAND } from "@/lib/api";
export default function HowItWorks() {
  return (
    <div className="text-white max-w-7xl mx-auto px-6 md:px-10 py-16">
      <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">How it works</p>
      <h1 className="font-display text-5xl md:text-6xl mb-4">Sparkling. In three steps.</h1>
      <p className="text-white/70 max-w-2xl mb-12">A demonstration of the Preshh GO workflow — designed to be as fast and reliable as the technology itself.</p>
      <div className="relative aspect-video rounded-3xl overflow-hidden mb-16 bg-[#111] border border-white/10 shadow-2xl">
        <video
          data-testid="how-it-works-demo-video"
          className="w-full h-full object-cover"
          src="/videos/preshh-demo-en.mp4"
          poster={BRAND.open}
          controls
          playsInline
          preload="metadata"
        />
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {[
          ["01", "Fill", "Fill the bottle with your beverage. Leave sufficient headspace for carbonation to occur properly."],
          ["02", "Connect & Inject", "Connect Preshh GO to the bottle. Inject CO₂ using the portable regulator."],
          ["03", "Agitate & Enjoy", "Follow the recommended agitation process. Pour and enjoy your sparkling beverage."],
        ].map(([n, t, d]) => (
          <div key={n} className="bg-[#111] border border-white/10 rounded-3xl p-8">
            <div className="text-6xl font-display text-[#00B5D8]/30">{n}</div>
            <h3 className="mt-4 font-bold text-2xl">{t}</h3>
            <p className="mt-3 text-white/60">{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
